module.exports = __webpack_public_path__ + "static/media/flatBed.42e41757.svg";